// extracted by mini-css-extract-plugin
module.exports = {"grid":"items_grid__O64jL"};